import { useState } from 'react'
import { publicUrlFor } from "../../../globals/constants";
import JobZImage from "../jobz-img";
import { NavLink } from "react-router-dom";
import { publicUser, candidate, canRoute } from "../../../globals/route-names";
import '../../../i18n';
import { useTranslation } from "react-i18next";
import axiosInstance from '../../../axiosInstance';
import { API_URL } from "../../../config";

function Footer1() {
    const { t } = useTranslation();
    const [email, setEmail] = useState('');
    const [error, setError] = useState('');
    const [message, setMessage] = useState('');

    const handleSubmit = async (e) => {
        e.preventDefault()
        setError('')
        setMessage('')

        try {
            const response = await axiosInstance.post(`${API_URL}/subscribe`, { email });
            console.log("API response:", response.data);
            setMessage(response.data.message)
            setEmail('')
        } catch (err) {
            const msg = err.response?.data?.message || 'Something went wrong.'
            if (msg.toLowerCase().includes('invalid email')) {
                setError('Invalid email format')
            } else {
                setError(msg)
            }
        }
    }
    return (
        <>
            <footer className="footer-dark" style={{ backgroundImage: `url(${publicUrlFor("images/f-bg.jpg")})` }}>
                <div className="container">
                    {/* NEWS LETTER SECTION START */}
                    {/* <div className="ftr-nw-content">
                        <div className="row">
                            <div className="col-md-5">
                                <div className="ftr-nw-title">
                                    Join our email subscription now to get updates
                                    on new jobs and notifications.
                                </div>
                            </div>
                            <div className="col-md-7">
                                <form onSubmit={handleSubmit}>
                                    <div className="ftr-nw-form">
                                        <input
                                            name="news-letter"
                                            className="form-control"
                                            placeholder="Enter Your Email"
                                            type="text"
                                            value={email}
                                            onChange={(e) => setEmail(e.target.value)}
                                        />
                                        <button type="submit" className="ftr-nw-subcribe-btn">Subscribe Now</button>
                                    </div>
                                    {error && <p style={{ color: 'red' }}>{error}</p>}
                                    {message && <p style={{ color: 'green' }}>{message}</p>}
                                </form>
                            </div>
                        </div>
                    </div> */}
                    {/* NEWS LETTER SECTION END */}

                    {/* FOOTER BLOCKES START */}
                    {/* <div className="footer-top"> */}
                    <div className="row">
                        <div className="col-lg-3 col-md-12">
                            <div className="widget widget_about">
                                <div className="logo-footer clearfix">
                                    <NavLink to={publicUser.INITIAL}><JobZImage id="skin_style" src="images/logo-light.png" alt="" /></NavLink>
                                </div>
                                <p>{t("CV Diffusion is a platform that uses artificial intelligence to help candidates find their dream jobs using automated applications.")}</p>
                                {/* <ul className="ftr-list">
                                    <li><p><span>Address :</span>65 Sunset CA 90026, USA </p></li>
                                    <li><p><span>Email :</span>example@max.com</p></li>
                                    <li><p><span>Call :</span>555-555-1234</p></li>
                                </ul> */}
                            </div>
                            <div className="d-flex align-items-centerfs-4 gap-2 mt-4">
                                <i className="text-primary  fa-2x fab fa-cc-stripe"></i>
                                <span>Powered By Stripe</span>
                            </div>
                        </div>
                        <div className="col-lg-9 col-md-12">
                            <div className="row">
                                <div className="col-lg-4 col-md-6 col-sm-6">
                                    <div className="widget widget_services ftr-list-center">
                                        <h3 className="widget-title">{t("For Candidate")}</h3>
                                        <ul>
                                            <li><NavLink to={canRoute(candidate.DASHBOARD)}>{t("User Dashboard")}</NavLink></li>
                                            <li><NavLink to={canRoute(candidate.PROFILE)}>{t("Candidate Profile")}</NavLink></li>
                                            <li><NavLink to={canRoute(candidate.ADDLOOP)}>{t("Add Loop")}</NavLink></li>
                                            {/* <li><NavLink to={publicUser.blog.DETAIL}>Blog single</NavLink></li> */}
                                        </ul>
                                    </div>
                                </div>
                                {/* <div className="col-lg-3 col-md-6 col-sm-6">
                                    <div className="widget widget_services ftr-list-center">
                                        <h3 className="widget-title">For Employers</h3>
                                        <ul>
                                            <li><NavLink to={publicUser.blog.GRID1}>Blog Grid</NavLink></li>
                                            <li><NavLink to={publicUser.pages.CONTACT}>Contact</NavLink></li>
                                            <li><NavLink to={publicUser.jobs.LIST}>Jobs Listing</NavLink></li>
                                            <li><NavLink to={publicUser.jobs.DETAIL1}>Jobs details</NavLink></li>
                                        </ul>
                                    </div>
                                </div> */}
                                <div className="col-lg-4 col-md-6 col-sm-6">
                                    <div className="widget widget_services ftr-list-center">
                                        <h3 className="widget-title">{t("Helpful Resources")}</h3>
                                        <ul>
                                            <li><NavLink to={publicUser.pages.FAQ}>{t("FAQs")}</NavLink></li>
                                            <li><NavLink to={publicUser.pages.CONTACT}>{t("Contact")}</NavLink></li>
                                            {/* <li><NavLink to={publicUser.pages.ERROR404}>404 Page</NavLink></li> */}
                                            <li><NavLink to={publicUser.pages.PRICING}>{t("Pricing")}</NavLink></li>
                                        </ul>
                                    </div>
                                </div>
                                <div className="col-lg-4 col-md-6 col-sm-6">
                                    <div className="widget widget_services ftr-list-center">
                                        <h3 className="widget-title">{t("Quick Links")}</h3>
                                        <ul>
                                            <li><NavLink to={publicUser.HOME1}>{t("Home")}</NavLink></li>
                                            <li><NavLink to={publicUser.pages.ABOUT}>{t("About Us")}</NavLink></li>
                                            {/* <li><NavLink to={publicUser.jobs.GRID}>Jobs</NavLink></li> */}
                                            <li><NavLink to={publicUser.employer.EMPLOYER}>{t("Employer")}</NavLink></li>
                                        </ul>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    {/* </div> */}

                    {/* FOOTER COPYRIGHT */}
                    <div className="footer-bottom">
                        <div className="footer-bottom-info d-flex justify-content-between align-items-center flex-wrap">
                            <div className="footer-copy-right">
                                <span className="copyrights-text">
                                    {t("Copyright")} © 2025 {t("by")} CV Diffusion. {t("All rights reserved.")}
                                </span>
                            </div>
                            <ul className="social-icons">
                                <li style={{ backgroundColor: 'rgba(69, 89, 237, 0.99)', borderRadius: '10px' }}>
                                    <a
                                        href="#"
                                        // target="_blank"
                                        className="inline-flex items-center px-4 py-2 bg-blue-600 text-white font-semibold rounded hover:bg-blue-700"
                                    >
                                        <i className="fab fa-facebook-f mr-2"></i> Facebook
                                    </a>
                                </li>
                                {/* <li><a href="https://www.twitter.com/" className="fab fa-twitter" /></li>
                                <li><a href="https://www.instagram.com/" className="fab fa-instagram" /></li>
                                <li><a href="https://www.youtube.com/" className="fab fa-youtube" /></li> */}
                            </ul>
                        </div>
                    </div>
                </div>
            </footer>
        </>
    );
}

export default Footer1;
